export var ASSESSMENT_TYPES = Object.freeze({
  SELF: "Self",
  PEER: "Peer",
  TEACHER: "Teacher"
});